import { ProductTypeRevision } from "../api/product-api";

export function filterDefaultLabelsForRevision(revision: ProductTypeRevision) {
    return revision.productTypeRevisionLabels!.filter(v => !v.label.description.includes("(archived)"));
}